import { apiClient } from '@borradh-workspace/api-client';
import type { StripeConnectIntegration } from '@borradh-workspace/api-client/types';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getStripeConnectionQueryOptions = () =>
  queryOptions({
    queryKey: ['integrations', 'stripe'],
    queryFn: async () => {
      const { integration } = await apiClient.get<{
        integration: StripeConnectIntegration | null;
      }>('integrations/stripe/integration');
      return integration;
    },
    staleTime: 5 * 60 * 1000,
  });

export const useGetStripeConnection = () => {
  const query = useQuery(getStripeConnectionQueryOptions());
  return {
    connection: query.data ?? null,
    /** An integration row exists, active or not. `isConnected` means active. */
    hasIntegration: query.data != null,
    isConnected: !!query.data?.isActive,
    chargesEnabled: query.data?.chargesEnabled ?? false,
    payoutsEnabled: query.data?.payoutsEnabled ?? false,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};
